'use strict';

module.exports = {
    onInvoiceValue: 'onInvoiceValue',
    offInvoiceValue: 'offInvoiceValue',
    buyingPrice: 'buyingPrice',
    supplierCompensation: 'supplierCompensation',
    guaranteedMargin: 'guaranteedMargin',
};
